import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
var a = ["aria-brailleroledescription", "aria-roledescription", "aria-label", "aria-labelledby", "aria-describedby", "aria-hidden", "aria-disabled", "aria-expanded", "aria-haspopup", "aria-relevant"], s = ["aria-live", "aria-atomic", "aria-busy"].concat(a), u = ["aria-pressed", "aria-controls"].concat(a), l = ["aria-checked", "aria-invalid", "aria-errormessage", "aria-readonly", "aria-controls"].concat(a), b = ["aria-invalid", "aria-required"].concat(a), d = ["aria-required", "aria-readonly", "aria-placeholder", "aria-invalid", "aria-errormessage", "aria-autocomplete", "aria-controls"].concat(a), v = ["aria-multiselectable", "aria-selected", "aria-expanded", "aria-haspopup"].concat(d, a), g = ["aria-modal"].concat(a), h = ["aria-current", "aria-disabled", "aria-label"].concat(a), f = ["aria-multiselectable", "aria-activedescendant"].concat(a), x = ["aria-level", "aria-posinset", "aria-setsize"].concat(a), y = ["aria-selected"].concat(a), k = ["aria-valuetext", "aria-valuenow", "aria-valuemin", "aria-valuemax"].concat(s, a), w = ["aria-checked", "aria-invalid", "aria-errormessage", "aria-controls"].concat(a), A = ["aria-selected", "aria-controls"].concat(a), c = ["aria-level"].concat(a), j = ["aria-rowcount", "aria-colcount", "aria-labelledby", "aria-describedby"].concat(a), z = ["aria-orientation", "aria-activedescendant"].concat(a), n = {
  alert: s,
  button: u,
  checkbox: l,
  combobox: v,
  dialog: g,
  textbox: d,
  link: h,
  listbox: f,
  listitem: x,
  option: y,
  progressbar: k,
  radio: l,
  radiogroup: b,
  switch: w,
  tab: A,
  tabpanel: a,
  heading: c,
  table: j,
  img: c,
  region: a,
  menu: z
}, O = {
  button: "button",
  a: "link",
  div: "region",
  input: "textbox",
  img: "img",
  form: "form",
  header: "banner",
  footer: "contentinfo",
  nav: "navigation",
  section: "region",
  article: "article",
  aside: "complementary",
  main: "main",
  table: "table",
  tr: "row",
  th: "columnheader",
  td: "cell",
  ul: "list",
  ol: "list",
  li: "listitem",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  progress: "progressbar",
  textarea: "textbox",
  select: "listbox",
  option: "option",
  dialog: "dialog",
  figure: "figure",
  figcaption: "figcaption",
  blockquote: "blockquote",
  time: "time",
  mark: "mark",
  meter: "meter",
  output: "output",
  summary: "summary",
  details: "details",
  abbr: "abbr",
  address: "address",
  b: "strong",
  i: "em",
  code: "code",
  pre: "pre",
  small: "small",
  sub: "sub",
  sup: "sup",
  var: "var",
  wbr: "wbr",
  canvas: "img",
  audio: "audio",
  video: "video",
  source: "source",
  track: "track",
  map: "map",
  area: "link",
  iframe: "document",
  embed: "embed",
  object: "object",
  picture: "img",
  template: "template",
  slot: "slot",
  del: "deletion",
  ins: "insertion",
  caption: "caption",
  col: "column",
  colgroup: "column",
  thead: "rowgroup",
  tbody: "rowgroup",
  tfoot: "rowgroup",
  fieldset: "group",
  legend: "legend",
  label: "label",
  datalist: "listbox",
  optgroup: "group",
  menu: "menu"
}, T = function(r) {
  return r.toLowerCase().replace(/-/g, "").replace(/^aria/, "aria-");
}, q = function(r) {
  return r === void 0 && (r = {}), Object.fromEntries(Object.entries(r).map(function(i) {
    var o = i[0], t = i[1];
    return [T(o), t];
  }));
};
function m(e, r) {
  r === void 0 && (r = {});
  var i = q(r), o = n[e] || n.region;
  return Object.fromEntries(Object.entries(i).filter(function(t) {
    var p = t[0];
    return o == null ? void 0 : o.includes(p);
  }));
}
function C(e, r) {
  r === void 0 && (r = {});
  var i = O[e] || "region", o = m(i, r);
  return o;
}
function $(e, r) {
  return e in n ? m(e, r) : C(e, r);
}
export {
  n as RoleToAriaKeysMap,
  O as TagNameToRoleMap,
  $ as getAriaProps,
  m as getAriaPropsByRole,
  C as getAriaPropsByTagName
};
